// src/status.js
// Keep in sync with sna-inv/src/scripts/colorCodes.js (canonical source).
export const STATUS_BY_CODE = {
  0:  { bg: '#FFFFFF', fg: '#000000', label: 'Unassigned'               },
  1:  { bg: '#C757FF', fg: '#ffffff', label: 'Sold'                     },
  2:  { bg: '#FFD966', fg: '#000000', label: 'Rented Out'               },
  3:  { bg: '#00B050', fg: '#ffffff', label: 'In Stock - Calgary'       },
  4:  { bg: '#92D050', fg: '#000000', label: 'In Transit to Calgary'    },
  5:  { bg: '#FF8A65', fg: '#ffffff', label: 'In Transit to Customer'   },
  6:  { bg: '#FF0000', fg: '#ffffff', label: 'Alert'                    },
  7:  { bg: '#FFCCFF', fg: '#000000', label: 'To Order'                 },
  8:  { bg: '#FFCCFF', fg: '#000000', label: 'On Order'                 },
  9:  { bg: '#92D050', fg: '#000000', label: 'Stock & PDI - In Calgary' },
  10: { bg: '#A78BFA', fg: '#ffffff', label: 'Demo'                     },
  11: { bg: '#94A3B8', fg: '#ffffff', label: 'Chassis Allocation Slot'  },
  12: { bg: '#FBBF24', fg: '#000000', label: 'Ready at Factory'         },
  13: { bg: '#DC2626', fg: '#ffffff', label: 'In Transit - Broke Down'  },
};

const normalize = (s) => String(s ?? '').trim().toLowerCase();

const LABEL_TO_CODE = Object.fromEntries(
  Object.entries(STATUS_BY_CODE).map(([code, v]) => [normalize(v.label), Number(code)])
);

export function parseBool(v) {
  const s = normalize(v);
  return v === true || v === 1 || v === '1' || s === 'true' || s === 'yes' || s === 'y';
}

export function getStatusMeta(record) {
  const alert = parseBool(record?.alert ?? record?.['alert.1']);
  if (alert) return { bg: '#FF0000', label: 'ALERT' };

  const raw = record?.unit_status ?? record?.['unit_status.1'] ?? '';

  const asNum = Number(raw);
  if (!Number.isNaN(asNum) && raw !== '' && raw !== null && raw !== undefined) {
    return STATUS_BY_CODE[asNum] || { bg: '#dbeafe', label: String(raw) };
  }

  const code = LABEL_TO_CODE[normalize(raw)];
  if (code !== undefined) return STATUS_BY_CODE[code];

  const cc = Number(record?.color_code);
  if (!Number.isNaN(cc) && record?.color_code !== '' && record?.color_code !== null && record?.color_code !== undefined) {
    return STATUS_BY_CODE[cc] || { bg: '#dbeafe', label: 'Unknown' };
  }

  return { bg: '#dbeafe', label: raw ? String(raw) : 'Unknown' };
}
